import type {
  AdminOnboardingDeleteRequest,
  AdminOnboardingDeleteResult,
  AdminOnboardingRecord,
  AdminOnboardingRow,
} from "../models/admin-onboarding.models";

export function toAdminOnboardingRows(records: AdminOnboardingRecord[]): AdminOnboardingRow[] {
  return records.map((record, index) => ({ ...record, gridRowId: `${record.RECORD_KEY}-${index}` }));
}

export function filterAdminOnboardingRows(rows: AdminOnboardingRow[], search: string): AdminOnboardingRow[] {
  const query = search.trim().toLowerCase();

  if (!query) {
    return rows;
  }

  return rows.filter((row) =>
    [row.VESSEL_NAME, row.VESSEL_CODE, row.IMO_NUMBER, row.EMAIL].some((value) => value?.toLowerCase().includes(query)),
  );
}

// Use the complete loaded table so search and column filters cannot hide records from confirmation.
export function getAdminOnboardingVesselRows(
  rows: AdminOnboardingRow[],
  vessel: AdminOnboardingRow,
): AdminOnboardingRow[] {
  return rows.filter((row) => row.VESSEL_CODE === vessel.VESSEL_CODE && row.IMO_NUMBER === vessel.IMO_NUMBER);
}

export function toAdminOnboardingDeleteRequest(rows: AdminOnboardingRow[]): AdminOnboardingDeleteRequest {
  return {
    vesselCode: rows[0].VESSEL_CODE,
    imoNumber: rows[0].IMO_NUMBER,
    recordKeys: Array.from(new Set(rows.map((row) => row.RECORD_KEY))),
  };
}

export function getAdminOnboardingDeleteMessage(result: AdminOnboardingDeleteResult): string {
  const deleted = `Deleted ${result.deletedCount} onboarding record${result.deletedCount === 1 ? "" : "s"}.`;

  if (result.remainingCount > 0) {
    return `${deleted} ${result.remainingCount} records remain for this vessel. Refresh and review them before re-ingestion.`;
  }

  return `${deleted} The vessel is eligible for the normal onboarding process to ingest it again using the current source email.`;
}

export function ignoreAdminOnboardingCellCommit(): void {}
